import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { Environments } from '~/constants/enums';
import { appApiSlice } from '~/redux/api/appApiSlice';
import { authApiSlice } from '~/redux/api/authApiSlice';
import uiStateReducer from '~/redux/features/uiState/uiStateSlice';
import listingReducer from '~/redux/features/listing/listingSlice';

export const store = configureStore({
  reducer: {
    [appApiSlice.reducerPath]: appApiSlice.reducer,
    [authApiSlice.reducerPath]: authApiSlice.reducer,

    uiState: uiStateReducer,
    listing: listingReducer,
  },
  devTools: process.env.REACT_APP_NODE_ENV === Environments.DEV,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(
      authApiSlice.middleware,
      appApiSlice.middleware,
    ),
});
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
